import React from 'react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import useSchoolSettings from '../../hooks/useSchoolSettings'
import '../../print.css'

// Shared A4 shell for every printable official document in the Admin Office
// module (หนังสือส่ง, บันทึกข้อความ, หนังสือรับรอง, หนังสือเชิญประชุม,
// รายงานการประชุม, สมุดหมายเหตุรายวัน). Renders an on-screen preview with a
// print button; @media print strips everything but the sheet itself.
//
// Props:
//   docNo      — เลขที่หนังสือ (แสดงมุมขวาบน เช่น "ที่ 001/2569") — optional
//   title      — ชื่อเอกสารกลางหน้า เช่น "หนังสือรับรอง" — optional
//   backLink   — path กลับหน้าทะเบียน
//   showCrest  — แสดงตราโรงเรียนกลางหัวกระดาษ (default true)
//   children   — เนื้อเอกสาร
export default function OfficialDocLayout({ docNo, title, backLink, showCrest = true, children }) {
  const school = useSchoolSettings()

  return (
    <div className="ao-print-wrap">
      <style>{`
        .ao-print-wrap { background: #6c757d; min-height: 100vh; padding: 24px 0; }
        .ao-print-toolbar { width: 21cm; margin: 0 auto 12px; display: flex; gap: 8px; justify-content: flex-end; }
        .ao-print-sheet {
          font-family: 'THSarabun', 'Roboto', Helvetica, Arial, sans-serif;
          font-size: 16pt; line-height: 1.45; color: #000;
          width: 21cm; min-height: 29.7cm; margin: 0 auto;
          background: #fff; padding: 1.8cm 2.2cm 2cm 2.5cm;
          box-shadow: 0 0 12px rgba(0,0,0,.35); box-sizing: border-box;
        }
        .ao-print-sheet .doc-no { text-align: right; }
        .ao-print-sheet .doc-crest { text-align: center; margin-bottom: 4px; }
        .ao-print-sheet .doc-crest img { height: 2.4cm; }
        .ao-print-sheet .doc-school { text-align: center; font-weight: bold; font-size: 18pt; }
        .ao-print-sheet .doc-school-sub { text-align: center; font-size: 14pt; }
        .ao-print-sheet .doc-title { text-align: center; font-weight: bold; font-size: 18pt; margin: 12px 0 8px; }
        .ao-print-sheet .doc-indent { text-indent: 2.5cm; }
        .ao-print-sheet .doc-sign { margin-top: 36px; text-align: center; }
        .ao-print-sheet table { font-size: inherit; }
        @media print {
          body * { visibility: hidden; }
          .ao-print-wrap { background: #fff; padding: 0; }
          .ao-print-sheet, .ao-print-sheet * { visibility: visible; }
          .ao-print-sheet {
            position: absolute; left: 0; top: 0; width: 100%;
            margin: 0; box-shadow: none; padding: 0.5cm 1cm 1cm 1.3cm;
          }
          .ao-print-toolbar { display: none; }
        }
        @page { size: A4 portrait; margin: 1cm; }
      `}</style>

      <div className="ao-print-toolbar">
        {backLink && (
          <Button as={Link} to={backLink} variant="light" size="sm">
            <i className="ri-arrow-left-line me-1" />กลับ
          </Button>
        )}
        <Button variant="primary" size="sm" onClick={() => window.print()}>
          <i className="ri-printer-line me-1" />พิมพ์
        </Button>
      </div>

      <div className="ao-print-sheet">
        {docNo && <div className="doc-no">ที่ {docNo}</div>}
        {showCrest && (
          <div className="doc-crest">
            <img src={school.logoSrc} alt="ตราโรงเรียน" />
          </div>
        )}
        <div className="doc-school">{school.school_name}</div>
        <div className="doc-school-sub">{school.school_address}</div>
        {title && <div className="doc-title">{title}</div>}
        {children}
      </div>
    </div>
  )
}
